export default (event, allowed) => {
  if (event.ctrlKey || event.metaKey) return;
  if (event.key.length > 1) return;

  if (!allowed.test(event.key)) {
    return event.preventDefault();
  }
};
